import { render, staticRenderFns } from "./OverlayImg.vue?vue&type=template&id=19a60e10&scoped=true&"
import script from "./OverlayImg.vue?vue&type=script&lang=js&"
export * from "./OverlayImg.vue?vue&type=script&lang=js&"
import style0 from "./OverlayImg.vue?vue&type=style&index=0&id=19a60e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a60e10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
